module.exports = __webpack_public_path__ + "static/media/RKProjectPrevieww935@1x.95e56a76.jpg";